import { definePlayerFeature } from "../../feature.js";
import { listen } from "@videojs/utils/dom";
import { isMediaErrorCapable } from "@videojs/media";
//#region src/dom/store/features/error.ts
const errorFeature = definePlayerFeature({
	name: "error",
	state: ({ set }) => ({
		error: null,
		dismissError() {
			set({ error: null });
		}
	}),
	attach({ target, signal, set }) {
		const { media } = target;
		if (!isMediaErrorCapable(media)) return;
		const syncError = () => set({ error: media.error });
		listen(media, "error", syncError, { signal });
		listen(media, "emptied", () => set({ error: null }), { signal });
	}
});
//#endregion
export { errorFeature };

//# sourceMappingURL=error.js.map